/** @jsxRuntime classic */
/** @jsx jsx */
import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import { css, jsx } from '@emotion/react';
import Axios from 'axios';
import React, { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addUser, ShowWrite } from '../redux/loginSlice';
import Footer from './layout/Footer';
import Header from './layout/HeaderB';
import './Styles.css';

function Auth() {
  const [registerUsername, setRegisterUsername] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');
  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const register = () => {
    Axios({
      method: 'POST',
      data: {
        username: registerUsername,
        password: registerPassword,
      },
      withCredentials: true,
      url: 'https://mern-stack-restaurants-app.herokuapp.com/register',
    }).then(response => {
      if (response.data === 'User Already Exists') {
        const notify = () => toast('User Already Exists!', { icon: '📞' });
        notify();
      } else if (response.data === 'User Created') {
        const notify = () => toast.success('User Created!');
        notify();
      } else {
        const notify = () => toast.error('An error occurred!');
        notify();
      }
      setRegisterUsername('');
      setRegisterPassword('');
    });
  };
  const login = () => {
    Axios({
      method: 'POST',
      data: {
        username: loginUsername,
        password: loginPassword,
      },
      withCredentials: true,
      url: 'https://mern-stack-restaurants-app.herokuapp.com/login',
    }).then(response => {
      if (response.data === 'Successfully Authenticated') {
        const notify = () => toast.success('User logged in!');
        notify();
        dispatch(ShowWrite());
        dispatch(addUser(loginUsername));
      } else if (response.data === 'Wrong credentials!') {
        const notify = () => toast('Wrong credentials!', { icon: '📞' });
        notify();
      } else {
        const notify = () => toast.error('An error occurred!');
        notify();
      }
      setLoginUsername('');
      setLoginPassword('');
    });
  };
  return (
    <React.Fragment>
      <Box
        css={{
          minHeight: 'calc(100vh - 80px)',
          marginBottom: '-5px',
        }}
      >
        <Toaster />
        <Header />
        <Flex direction="row" wrap="wrap" justify="center" mb={10}>
          <Flex direction="column">
            <Heading
              css={css`
                @media (max-width: 350px) {
                  font-size: 16px;
                }
              `}
              as="u"
              mb={5}
            >
              Register
            </Heading>
            <input
              placeholder="Username"
              type="text"
              onChange={e => setRegisterUsername(e.target.value)}
              value={registerUsername}
              css={css`
                padding: 10px 5px;
                margin-bottom: 10px;
                @media (max-width: 350px) {
                  font-size: 13px;
                }
              `}
            />
            <input
              placeholder="Password"
              type="password"
              onChange={e => setRegisterPassword(e.target.value)}
              value={registerPassword}
              css={css`
                padding: 10px 5px;
                margin-bottom: 10px;
                @media (max-width: 350px) {
                  font-size: 13px;
                }
              `}
            />
            <Button
              onClick={register}
              disabled={registerUsername === '' || registerPassword === ''}
              css={css`
                @media (max-width: 350px) {
                  font-size: 13px;
                  height: 55px;
                }
              `}
              colorScheme="blue"
            >
              Submit
            </Button>
          </Flex>
          <Flex direction="column" ml={10}>
            <Heading
              css={css`
                @media (max-width: 350px) {
                  font-size: 16px;
                }
              `}
              as="u"
              mb={5}
            >
              Login
            </Heading>
            <input
              placeholder="Username"
              type="text"
              required
              onChange={e => setLoginUsername(e.target.value)}
              value={loginUsername}
              css={css`
                padding: 10px 5px;
                margin-bottom: 10px;
                @media (max-width: 350px) {
                  font-size: 13px;
                }
              `}
            />
            <input
              placeholder="Password"
              type="text"
              required
              onChange={e => setLoginPassword(e.target.value)}
              value={loginPassword}
              css={css`
                padding: 10px 5px;
                margin-bottom: 10px;
                @media (max-width: 350px) {
                  font-size: 13px;
                }
              `}
            />
            <Button
              onClick={login}
              disabled={loginUsername === '' || loginPassword === ''}
              css={css`
                @media (max-width: 350px) {
                  font-size: 13px;
                }
              `}
              colorScheme="blue"
            >
              Submit
            </Button>
          </Flex>
        </Flex>
      </Box>
      <Footer />
      <Button
        onClick={() => navigate(-1)}
        css={css`
          position: fixed;
          zindex: 100;
          top: 35%;
          left: 0;
          @media (max-width: 350px) {
            font-size: 13px;
          }
        `}
        colorScheme="blue"
      >
        Back
      </Button>
    </React.Fragment>
  );
}

export default Auth;
